import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { BookOpenIcon, LayoutGridIcon, MessageSquareIcon, HomeIcon, ShieldCheckIcon } from 'lucide-react';
export function WhatYouGet() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const deliverables = [{
    icon: BookOpenIcon,
    title: 'The 48-Hour Recovery Guide',
    description: 'A step-by-step roadmap from the Friday night "Announcement" to the Sunday night "New Normal."'
  }, {
    icon: LayoutGridIcon,
    title: 'The Activity Menu Matrix',
    description: 'A curated list of neuro-compatible activities that soothe the nervous system during detox.'
  }, {
    icon: MessageSquareIcon,
    title: 'The Boredom Bridge Scripts',
    description: 'Exactly what to say when the whining starts so you stay in control without yelling.'
  }, {
    icon: HomeIcon,
    title: 'The Screen-Free Home Audit',
    description: 'How to rearrange your environment to remove the visual "triggers" that cause cravings.'
  }, {
    icon: ShieldCheckIcon,
    title: 'The Sustainable Screen Rulebook',
    description: 'A long-term framework for reintroducing tech without losing your progress.'
  }];
  return <section ref={ref} className="px-6 py-20" style={{
    backgroundColor: 'var(--color-background)'
  }} data-id="element-111">
      <div className="max-w-3xl mx-auto" data-id="element-112">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="text-3xl md:text-4xl font-bold mb-4 text-center" style={{
        fontFamily: 'var(--font-heading)',
        color: 'var(--color-text)'
      }} data-id="element-113">
          What You Get
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        ease: 'easeOut',
        delay: 0.1
      }} className="text-center text-lg mb-12 opacity-70" style={{
        color: 'var(--color-text)'
      }} data-id="element-114">
          Everything you need to execute a successful screen detox weekend.
        </motion.p>

        <div className="space-y-4" data-id="element-115">
          {deliverables.map((item, index) => <motion.div key={item.title} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          ease: 'easeOut',
          delay: 0.15 + index * 0.08
        }} className="flex items-start gap-5 p-5 rounded-lg" style={{
          backgroundColor: 'var(--color-background-alt)'
        }} data-id="element-116">
              <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
            backgroundColor: 'var(--color-accent)'
          }} data-id="element-117">
                <item.icon className="w-6 h-6 text-white" data-id="element-118" />
              </div>
              <div data-id="element-119">
                <h3 className="text-xl font-semibold mb-1" style={{
              fontFamily: 'var(--font-heading)',
              color: 'var(--color-text)'
            }} data-id="element-120">
                  {item.title}
                </h3>
                <p style={{
              color: 'var(--color-text)',
              opacity: 0.8
            }} data-id="element-121">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}